// hooks/useScrollToTop.js
import { useEffect } from 'react';

const useScrollToTop = (deps = []) => {
  useEffect(() => {
    // Scroll to top smoothly
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, deps);
};

export default useScrollToTop;